import axios from "axios";
import Cookies from "js-cookie";
const BASEURL = process.env.REACT_APP_ENDPOINT;

const instance = axios.create({
  baseURL: BASEURL,
});

instance.interceptors.request.use(
  (config) => {
    const token = Cookies.get("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);

export default instance;
